import { openModalWithProps } from "actions/modal/openModalWithProps";
import { MODAL } from "constants";
/**
 * @name showUpdateEmailAddressModal
 * @desc opens MODAL.UPDATE_EMAIL_ADDRESS_MODAL with correct header
 * @returns function
 * @memberof actions.modal
 * @example
 * dispatch(showUpdateEmailAddressModal);
 */
export const showUpdateEmailAddressModal = () => (dispatch) => {
    dispatch(openModalWithProps(MODAL.UPDATE_EMAIL_ADDRESS_MODAL));
};